module.exports = __webpack_public_path__ + "contact-duo.jpg?9680d6acc3878dc0f89e660d118b4e60";


//////////////////
// WEBPACK FOOTER
// ./src/images/contact-duo.jpg
// module id = 384
// module chunks = 0